import { useState } from 'react';
import { CircularProgress } from '@mui/material';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Dropdown from 'react-bootstrap/Dropdown';
import Form from 'react-bootstrap/Form';

function ConsumerSelectInput({ label, initialValue, labelClassName, options, onSave }) {
  const [value, setValue] = useState(initialValue);
  const [spinner, setSpinner] = useState(false);

  const handleSave = async v => {
    setSpinner(true);
    await onSave(v);
    setValue(v);
    setSpinner(false);
  };

  return (
    <>
      <Form.Label className={`bo-consumer-input-label ${labelClassName}`}>{label}</Form.Label>
      <Dropdown>
        <Dropdown.Toggle className="bo-consumer-select-input w-100">
          <p className="p-0 m-0">{options.find(x => x.value === value).name}</p>
          {spinner ? (
            <CircularProgress color="inherit" size={16} className="ms-auto" />
          ) : (
            <FontAwesomeIcon
              icon={faAngleDown}
              color="#5946A4"
              className="bo-consumer-select-input-icon"
            />
          )}
        </Dropdown.Toggle>
        <Dropdown.Menu className="bo-consumer-dropdown-menu">
          {options.map(x => (
            <Dropdown.Item
              key={x.key}
              className="bo-consumer-dropdown-menu-item"
              onClick={() => handleSave(x.value)}
            >
              {x.name}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
}

export default ConsumerSelectInput;
